export interface ProductSpec {
  label: string;
  value: string;
}

export interface ProductDetail {
  id: number;
  nameAr: string;
  category: string;
  badge?: string;
  rating: number;
  reviews: number;
  price: number;
  originalPrice: number;
  stock: number;
  shortDesc: string;
  longDesc: string;
  images: string[];
  highlights: string[];
  specs: ProductSpec[];
  inBox: string[];
  relatedIds: number[];
}

export const productDetails: ProductDetail[] = [
  {
    id: 1,
    nameAr: "بلايستيشن 5",
    category: "PS5",
    badge: "الأكثر مبيعاً",
    rating: 5,
    reviews: 248,
    price: 2199,
    originalPrice: 2499,
    stock: 12,
    shortDesc: "جهاز الجيل القادم بسرعة خارقة وصوت ثلاثي الأبعاد",
    longDesc: "بلايستيشن 5 يجلب لك تجربة ألعاب لم تشهدها من قبل. بفضل SSD المخصص عالي السرعة، ستنسى وقت التحميل تماماً. تقنية Ray Tracing الحقيقية تمنحك إضاءة واقعية مذهلة، والـ DualSense يجعلك تشعر بكل لحظة في اللعبة بفضل اللمس التكيفي والمحركات الهابتيك.",
    images: [
      "https://public.readdy.ai/ai/img_res/1f9acddaf8f1458ad7078c5836ac6ac1.jpg",
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%205%20console%20top%20view%20flat%20lay%20on%20dark%20matte%20black%20surface%2C%20product%20photography%20studio%20quality%2C%20crisp%20sharp%20details%2C%20clean%20minimal%20background%2C%20premium%20gaming%20hardware%2C%20bird%20eye%20view&width=900&height=700&seq=ps5d02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%205%20white%20console%20back%20ports%20HDMI%20USB%20side%20view%20close%20up%20on%20dark%20background%2C%20product%20photography%2C%20studio%20lighting%2C%20detailed%20technical%20shot%2C%20clean%20minimal%20background&width=900&height=700&seq=ps5d03&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%205%20console%20with%20DualSense%20controller%20together%20on%20dark%20ambient%20lit%20surface%2C%20cinematic%20product%20photography%2C%20premium%20gaming%2C%20moody%20dramatic%20light%2C%20no%20text&width=900&height=700&seq=ps5d04&orientation=landscape"
    ],
    highlights: [
      "رسومات 4K بمعدل 120 إطار في الثانية",
      "وقت تحميل شبه فوري بفضل SSD مخصص",
      "صوت 3D ثلاثي الأبعاد غامر",
      "يد DualSense مع تقنية اللمس التكيفي",
      "دعم 8K كامل",
      "مشغّل بلو-راي 4K مدمج",
    ],
    specs: [
      { label: "المعالج", value: "AMD Zen 2 — 8 أنوية / 3.5 GHz" },
      { label: "معالج الرسومات", value: "AMD RDNA 2 — 10.28 TFLOPS" },
      { label: "الذاكرة العشوائية", value: "16 GB GDDR6" },
      { label: "التخزين", value: "825 GB SSD مخصص" },
      { label: "دقة الصورة", value: "4K / 8K" },
      { label: "معدل الإطارات", value: "حتى 120 FPS" },
      { label: "الصوت", value: "Tempest 3D Audio" },
      { label: "الاتصال", value: "USB-A, USB-C, HDMI 2.1, Ethernet" },
      { label: "بلوتوث", value: "Bluetooth 5.1" },
      { label: "واي فاي", value: "Wi-Fi 6 (802.11ax)" },
      { label: "الأبعاد", value: "39 × 26 × 10.4 سم" },
      { label: "الوزن", value: "4.5 كيلوجرام" },
    ],
    inBox: ["جهاز PS5", "يد DualSense", "كابل HDMI 2.1", "كابل USB Type-C", "كابل طاقة AC", "قاعدة عمودية", "قرص ترحيبي"],
    relatedIds: [2, 5, 6],
  },
  {
    id: 2,
    nameAr: "بلايستيشن 5 ديجيتال",
    category: "PS5",
    badge: "جديد",
    rating: 5,
    reviews: 134,
    price: 1899,
    originalPrice: 2099,
    stock: 8,
    shortDesc: "نفس قوة PS5 بتصميم أنحف بدون قارئ الأقراص",
    longDesc: "PS5 الإصدار الديجيتال يمنحك نفس القوة الهائلة لبلايستيشن 5 بتصميم أخف وأنحف، مع الاعتماد الكامل على المتجر الرقمي للحصول على الألعاب. الخيار المثالي لمن يفضل الشراء الرقمي والتوفير في السعر دون التنازل عن أي أداء.",
    images: [
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%205%20Digital%20Edition%20slim%20white%20console%20standing%20on%20dark%20charcoal%20background%2C%20product%20photography%2C%20minimalist%20studio%20lighting%2C%20clean%20crisp%20shot%2C%20premium%20gaming%20hardware%2C%20sharp%20details%2C%20elegant%20design&width=900&height=700&seq=ps5dig01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%205%20Digital%20Edition%20console%20front%20face%20detailed%20view%20on%20pure%20black%20background%2C%20studio%20product%20photography%2C%20clean%20minimal%2C%20sharp%20details%2C%20no%20disc%20slot%20visible%2C%20premium%20white%20finish&width=900&height=700&seq=ps5dig02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=PlayStation%205%20Digital%20Edition%20slim%20console%20side%20profile%20on%20dark%20background%2C%20product%20photography%20studio%20quality%2C%20minimalist%20clean%20look%2C%20sharp%20crisp%20details%2C%20modern%20design%20language&width=900&height=700&seq=ps5dig03&orientation=landscape",
      "https://readdy.ai/api/search-image?query=PS5%20Digital%20Edition%20white%20console%20with%20white%20DualSense%20controller%20on%20dark%20surface%2C%20cinematic%20product%20photography%2C%20moody%20studio%20lighting%2C%20premium%20gaming%20setup%2C%20clean%20background&width=900&height=700&seq=ps5dig04&orientation=landscape"
    ],
    highlights: [
      "نفس أداء PS5 الكاملة 100%",
      "تصميم أنحف وأخف وزناً",
      "بدون قارئ أقراص — كل شيء رقمي",
      "SSD 825 GB فائق السرعة",
      "صوت 3D غامر",
      "4K بمعدل 120 FPS",
    ],
    specs: [
      { label: "المعالج", value: "AMD Zen 2 — 8 أنوية / 3.5 GHz" },
      { label: "معالج الرسومات", value: "AMD RDNA 2 — 10.28 TFLOPS" },
      { label: "الذاكرة العشوائية", value: "16 GB GDDR6" },
      { label: "التخزين", value: "825 GB SSD مخصص" },
      { label: "دقة الصورة", value: "4K / 8K" },
      { label: "معدل الإطارات", value: "حتى 120 FPS" },
      { label: "قارئ الأقراص", value: "غير متوفر (رقمي فقط)" },
      { label: "الصوت", value: "Tempest 3D Audio" },
      { label: "الاتصال", value: "USB-A, USB-C, HDMI 2.1" },
      { label: "واي فاي", value: "Wi-Fi 6 (802.11ax)" },
      { label: "الأبعاد", value: "35.8 × 21.6 × 9.2 سم" },
      { label: "الوزن", value: "3.6 كيلوجرام" },
    ],
    inBox: ["جهاز PS5 ديجيتال", "يد DualSense", "كابل HDMI 2.1", "كابل USB Type-C", "كابل طاقة AC", "قاعدة عمودية"],
    relatedIds: [1, 5, 6],
  },
  {
    id: 3,
    nameAr: "بلايستيشن 4 برو",
    category: "PS4",
    badge: "خصم 15%",
    rating: 4,
    reviews: 512,
    price: 1099,
    originalPrice: 1299,
    stock: 3,
    shortDesc: "مكتبة ضخمة بآلاف الألعاب بدقة 4K HDR",
    longDesc: "بلايستيشن 4 برو الخيار المثالي لمن يبحث عن تجربة ألعاب ممتازة بسعر أكثر توفيراً. يدعم دقة 4K الحقيقية وتقنية HDR لألوان أكثر حيوية. مكتبته تضم آلاف العناوين الرائعة ويدعم PSVR للواقع الافتراضي.",
    images: [
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%204%20Pro%20sleek%20black%20gaming%20console%20on%20dark%20background%20with%20subtle%20ambient%20light%2C%20product%20photography%2C%20studio%20quality%2C%20clean%20minimal%20background%2C%20sharp%20crisp%20details%2C%20premium%20finish&width=900&height=700&seq=ps4pr01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=PlayStation%204%20Pro%20black%20console%20top%20view%20flat%20lay%20on%20dark%20matte%20surface%2C%20product%20photography%20studio%20quality%2C%20clean%20minimal%20background%2C%20detailed%20sharp%20shot%2C%20premium%20gaming%20hardware&width=900&height=700&seq=ps4pr02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=PS4%20Pro%20black%20console%20side%20view%20back%20ports%20HDMI%20USB%20on%20dark%20background%2C%20detailed%20product%20photography%2C%20studio%20lighting%2C%20clean%20minimal%20sharp%20technical%20shot&width=900&height=700&seq=ps4pr03&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sony%20PlayStation%204%20Pro%20console%20with%20DualShock%204%20controller%20on%20dark%20reflective%20surface%2C%20cinematic%20product%20photography%2C%20moody%20dramatic%20lighting%2C%20premium%20studio%20shot&width=900&height=700&seq=ps4pr04&orientation=landscape"
    ],
    highlights: [
      "دقة 4K HDR حقيقية",
      "يدعم PSVR للواقع الافتراضي",
      "آلاف الألعاب في مكتبة PS4",
      "مشغّل بلو-راي مدمج",
      "Share Play — العب مع صديقك عن بُعد",
      "HDD 1TB قابل للترقية",
    ],
    specs: [
      { label: "المعالج", value: "AMD Jaguar — 8 أنوية / 2.1 GHz" },
      { label: "معالج الرسومات", value: "AMD GCN — 4.2 TFLOPS" },
      { label: "الذاكرة العشوائية", value: "8 GB GDDR5" },
      { label: "التخزين", value: "1 TB HDD" },
      { label: "دقة الصورة", value: "1080p / 4K (مع دعم HDR)" },
      { label: "معدل الإطارات", value: "حتى 60 FPS" },
      { label: "قارئ الأقراص", value: "Blu-ray 6x CAV" },
      { label: "الصوت", value: "7.1 Surround (عبر HDMI)" },
      { label: "الاتصال", value: "USB 3.1 ×3، HDMI 2.0، Optical" },
      { label: "واي فاي", value: "Wi-Fi 802.11 a/b/g/n/ac" },
      { label: "الأبعاد", value: "29.5 × 32.7 × 5.5 سم" },
      { label: "الوزن", value: "3.3 كيلوجرام" },
    ],
    inBox: ["جهاز PS4 Pro", "يد DualShock 4", "كابل HDMI", "كابل USB", "كابل طاقة AC"],
    relatedIds: [5, 6, 1],
  },
  {
    id: 4,
    nameAr: "كمبيوتر ألعاب RTX 4080",
    category: "PC",
    badge: "حصري",
    rating: 5,
    reviews: 87,
    price: 4599,
    originalPrice: 5199,
    stock: 5,
    shortDesc: "أقصى قدرة بمعالج i9 وRTX 4080 للألعاب 4K",
    longDesc: "كمبيوتر الألعاب الأقوى في متجرنا. مزود بمعالج Intel Core i9 من الجيل الثالث عشر مع كرت شاشة NVIDIA RTX 4080 الأحدث، يمنحك تجربة ألعاب 4K بأعلى الإعدادات مع Ray Tracing الكامل ودعم DLSS 3.0 لرسومات سينمائية مذهلة.",
    images: [
      "https://readdy.ai/api/search-image?query=powerful%20gaming%20desktop%20PC%20tower%20with%20RGB%20lighting%20glowing%20red%20and%20amber%20on%20pure%20black%20background%2C%20product%20photography%2C%20studio%20quality%2C%20clean%20background%2C%20premium%20build%2C%20dramatic%20lighting%2C%20high%20end%20hardware%20components%20visible%20through%20glass%20panel&width=900&height=700&seq=pcdt01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=gaming%20PC%20tower%20close%20up%20side%20glass%20panel%20showing%20RGB%20lit%20components%20motherboard%20GPU%20RAM%20on%20dark%20background%2C%20product%20photography%2C%20studio%20lighting%2C%20detailed%20tech%20shot%2C%20clean%20background&width=900&height=700&seq=pcdt02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=gaming%20desktop%20computer%20tower%20front%20panel%20close%20up%20with%20RGB%20fans%20cooling%20system%20glowing%20amber%20on%20black%20background%2C%20detailed%20product%20photography%2C%20studio%20quality%20sharp%20details&width=900&height=700&seq=pcdt03&orientation=landscape",
      "https://readdy.ai/api/search-image?query=high%20end%20gaming%20PC%20setup%20on%20dark%20desk%20with%20RGB%20monitor%20keyboard%20mouse%20matching%20aesthetic%2C%20cinematic%20product%20photography%2C%20premium%20gaming%20station%2C%20moody%20dramatic%20lighting&width=900&height=700&seq=pcdt04&orientation=landscape"
    ],
    highlights: [
      "Intel Core i9-13900K أسرع معالج للألعاب",
      "NVIDIA RTX 4080 لألعاب 4K Ultra",
      "Ray Tracing & DLSS 3.0 كاملة",
      "32 GB DDR5 6000MHz",
      "2 TB NVMe Gen4 — تحميل فوري",
      "تبريد سائل 360mm",
    ],
    specs: [
      { label: "المعالج", value: "Intel Core i9-13900K (24 نواة / 5.8 GHz)" },
      { label: "كرت الشاشة", value: "NVIDIA GeForce RTX 4080 16GB GDDR6X" },
      { label: "الذاكرة العشوائية", value: "32 GB DDR5 6000MHz" },
      { label: "التخزين الأساسي", value: "2 TB NVMe Gen4 SSD" },
      { label: "التخزين الثانوي", value: "4 TB HDD" },
      { label: "اللوحة الأم", value: "ASUS ROG Strix Z790-E" },
      { label: "مزود الطاقة", value: "Corsair 1000W 80+ Gold" },
      { label: "التبريد", value: "سائل 360mm AIO" },
      { label: "نظام التشغيل", value: "Windows 11 Pro" },
      { label: "المنافذ", value: "USB 3.2, USB-C, HDMI 2.1, DP 1.4" },
      { label: "واي فاي", value: "Wi-Fi 6E + Bluetooth 5.3" },
      { label: "الأبعاد", value: "50 × 22 × 48 سم" },
    ],
    inBox: ["برج الكمبيوتر", "كابل طاقة", "دليل التشغيل", "أقراص السائقين", "حامل كرت الشاشة"],
    relatedIds: [1, 5, 6],
  },
  {
    id: 5,
    nameAr: "يد DualSense لاسلكية",
    category: "Controllers",
    badge: "",
    rating: 5,
    reviews: 389,
    price: 299,
    originalPrice: 349,
    stock: 25,
    shortDesc: "اشعر بكل لحظة في اللعبة بتقنية اللمس التكيفي",
    longDesc: "يد DualSense تُعيد تعريف ما يعنيه أن تُحس باللعبة. المحركات الهابتيك المتقدمة والأزرار التكيفية تمنحك ردود أفعال حقيقية من داخل اللعبة — سواء كانت توتر قوس وسهم، أو مقاومة المحرك، أو أحاسيس السطح. ميكروفون داخلي مدمج وبطارية طويلة الأمد.",
    images: [
      "https://readdy.ai/api/search-image?query=Sony%20DualSense%20PlayStation%205%20white%20wireless%20controller%20floating%20against%20deep%20black%20background%2C%20product%20photography%2C%20studio%20lighting%20from%20above%2C%20clean%20minimalist%20background%2C%20sharp%20crisp%20details%2C%20modern%20ergonomic%20design&width=900&height=700&seq=dsen01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=DualSense%20controller%20front%20face%20detailed%20view%20showing%20touchpad%20buttons%20analog%20sticks%20on%20dark%20background%2C%20product%20photography%20studio%20quality%2C%20sharp%20clean%20details%2C%20premium%20white%20black%20finish&width=900&height=700&seq=dsen02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sony%20DualSense%20controller%20back%20view%20showing%20L2%20R2%20adaptive%20triggers%20grip%20texture%20on%20dark%20background%2C%20product%20photography%2C%20studio%20lighting%2C%20detailed%20technical%20shot%2C%20clean%20background&width=900&height=700&seq=dsen03&orientation=landscape",
      "https://readdy.ai/api/search-image?query=DualSense%20PlayStation%205%20controller%20side%20profile%20showing%20USB-C%20port%20and%20speaker%20grille%20on%20dark%20background%2C%20studio%20product%20photography%2C%20clean%20minimal%20shot%2C%20sharp%20detail&width=900&height=700&seq=dsen04&orientation=landscape"
    ],
    highlights: [
      "أزرار تكيفية L2/R2 مع مقاومة حقيقية",
      "محركات هابتيك مزدوجة متقدمة",
      "ميكروفون مدمج عالي الجودة",
      "مكبر صوت داخلي",
      "شحن عبر USB-C",
      "بطارية تدوم حتى 12 ساعة",
    ],
    specs: [
      { label: "الاتصال", value: "لاسلكي Bluetooth 5.1" },
      { label: "عمر البطارية", value: "حتى 12 ساعة" },
      { label: "الشحن", value: "USB-C / محطة شحن" },
      { label: "الوزن", value: "280 جرام" },
      { label: "الأزرار التكيفية", value: "L2 / R2 مع مقاومة ديناميكية" },
      { label: "الهابتيك", value: "محركات مزدوجة متقدمة" },
      { label: "اللوحة اللمسية", value: "نعم — ClickPad" },
      { label: "الميكروفون", value: "مدمج — أحادي" },
      { label: "مكبر الصوت", value: "مدمج" },
      { label: "التوافق", value: "PS5، PC، Mac" },
      { label: "الألوان المتاحة", value: "أبيض، أسود، كوزميك ريد" },
      { label: "ضمان", value: "سنة كاملة" },
    ],
    inBox: ["يد DualSense", "كابل USB-C (1م)", "دليل التشغيل"],
    relatedIds: [6, 1, 2],
  },
  {
    id: 6,
    nameAr: "سماعة ألعاب احترافية",
    category: "Headsets",
    badge: "تخفيض",
    rating: 4,
    reviews: 201,
    price: 449,
    originalPrice: 549,
    stock: 0,
    shortDesc: "صوت محيطي 7.1 مع ميكروفون إلغاء ضوضاء",
    longDesc: "سماعة الألعاب الاحترافية مصممة للاعبين الجادين الذين لا يقبلون أقل من الأفضل. بإضاءة RGB مذهلة وصوت محيطي 7.1 حقيقي وميكروفون قابل للإزالة مع تقنية إلغاء الضوضاء، ستغمر نفسك في اللعبة وتسمع كل تفصيلة بوضوح كامل.",
    images: [
      "https://readdy.ai/api/search-image?query=premium%20gaming%20headset%20with%20red%20RGB%20lighting%20glowing%20on%20dark%20black%20background%2C%20product%20photography%2C%20studio%20quality%20shot%2C%20floating%20headphones%2C%20clean%20dark%20background%2C%20sleek%20modern%20design%2C%20dramatic%20amber%20glow&width=900&height=700&seq=hs01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=gaming%20headset%20close%20up%20ear%20cup%20showing%20RGB%20LED%20pattern%20on%20dark%20background%2C%20product%20photography%20studio%20quality%2C%20detailed%20shot%2C%20premium%20materials%2C%20soft%20memory%20foam%20padding%20visible%2C%20clean%20minimal&width=900&height=700&seq=hs02&orientation=landscape",
      "https://readdy.ai/api/search-image?query=gaming%20headset%20microphone%20boom%20arm%20close%20up%20on%20dark%20background%2C%20product%20photography%2C%20studio%20lighting%2C%20detailed%20shot%20showing%20flexible%20mic%20with%20pop%20filter%2C%20clean%20minimal%20background&width=900&height=700&seq=hs03&orientation=landscape",
      "https://readdy.ai/api/search-image?query=gaming%20headset%20top%20view%20showing%20headband%20cushion%20and%20adjustable%20slider%20on%20dark%20surface%2C%20product%20photography%20studio%20quality%2C%20detailed%20overhead%20shot%2C%20premium%20materials%2C%20clean%20background&width=900&height=700&seq=hs04&orientation=landscape"
    ],
    highlights: [
      "صوت محيطي 7.1 حقيقي",
      "إضاءة RGB قابلة للتخصيص",
      "ميكروفون قابل للإزالة",
      "إلغاء الضوضاء النشط",
      "وسائد أذن ذاكرة فوم فاخرة",
      "متوافق مع PS5/PS4/PC/Xbox",
    ],
    specs: [
      { label: "نوع الصوت", value: "7.1 Surround Sound" },
      { label: "قطر مشغّل الصوت", value: "50 مم" },
      { label: "استجابة التردد", value: "20 Hz – 20,000 Hz" },
      { label: "نسبة إشارة/ضوضاء", value: "95 dB" },
      { label: "الميكروفون", value: "مزدوج اتجاهي — قابل للإزالة" },
      { label: "إلغاء الضوضاء", value: "نشط (ANC)" },
      { label: "الاتصال", value: "USB + 3.5mm" },
      { label: "طول الكابل", value: "2 متر مضفر" },
      { label: "الإضاءة", value: "RGB — 16.8 مليون لون" },
      { label: "الوزن", value: "340 جرام" },
      { label: "التوافق", value: "PS5, PS4, PC, Xbox, Mobile" },
      { label: "ضمان", value: "سنة كاملة" },
    ],
    inBox: ["سماعة الألعاب", "ميكروفون قابل للإزالة", "كابل USB", "كابل 3.5mm", "دليل التشغيل"],
    relatedIds: [5, 1, 2],
  },
];
